import * as fromAuth from './actions/auth.actions';
import * as fromCore from './reducers/index';
import * as fromRoot from '../reducers/index';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { first, map, switchMap, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { UserState } from './reducers/auth.reducer';

@Injectable()
export class AuthentificationResolver implements Resolve<boolean> {
  constructor(private store: Store<fromRoot.AppState>) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.store.pipe(
      select(fromCore.selectAuth),
      take(1), // Take the current value of the auth state
      switchMap((userState: UserState) => {
        if (!userState.isAuthChecked) {
          // If auth state has not been checked, proceed with initProfileData
          this.initProfileData();
        }
        // Wait for the auth check to complete, regardless of whether initProfileData was called
        return this.waitForProfileDataToLoad();
      }),
    );
  }

  /**
   * Fallback when the APP_INITIALIZER auth bootstrap has not run/completed.
   * The initializer (authInitFactory) is the single owner of token
   * verification — the resolver only marks the check as done so routing can
   * proceed, instead of firing a duplicate /auth/me verification.
   */
  initProfileData(): void {
    this.store.dispatch(fromAuth.authCheck());
  }

  /**
   * wait untin auth checked state is equal to true
   */
  waitForProfileDataToLoad(): Observable<boolean> {
    return this.store.pipe(
      select(fromCore.selectAuth),
      map((userState: UserState) => userState.isAuthChecked),
      first((checked: boolean) => checked === true),
    );
  }
}
